import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { SiveActionResult } from "models/SiveActionResult";
import { SuggestedAgendaItemModel } from "models/SuggestedAgendaItemModel";

export class SuggestedAgendaItemsApi {
  constructor(private axios: AxiosInstance) {}

  async getCount(meetingId: number, signal: AbortSignal): Promise<number> {
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`suggestedAgendaItems/count/${meetingId}`);
    const response = await this.axios.get<number>(url, { signal });
    return response.data;
  }

  async getItems(meetingId: number, signal: AbortSignal): Promise<SuggestedAgendaItemModel[]> {
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`suggestedAgendaItems/${meetingId}`);
    const response = await this.axios.get<SuggestedAgendaItemModel[]>(url, { signal });
    return response.data;
  }

  async moveTo(itemIds: number[], meetingId: number) {
    if (!itemIds) throw new Error("itemIds is required");
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`suggestedAgendaItems/moveTo/${meetingId}`);
    const response = await this.axios.post<SiveActionResult>(url, itemIds);
    return response.data;
  }

  async delete(itemIds: number[]) {
    if (!itemIds) throw new Error("itemIds is required");
    const url = getBoardApiUrl(`suggestedAgendaItems/delete`);
    const response = await this.axios.post<SiveActionResult>(url, itemIds);
    return response.data;
  }
}
